export const LABELS = {
  EMPTY_DATA: "表示するデータがありません。",
  BTNS: {
    CONFIRM: "確認",
    CANCEL: "キャンセル",
  },
  PREFERENCE: {
    TITLE: "基本設定",
    SIZE_TITLE: "ページサイズ",
    CONTENT_TITLE: "表示可能な列を選択",
  },
} as const;
